import { useState, useEffect } from 'react';
import { isBrowser } from 'ws-scripts/modules/environment';
import logger from 'ws-scripts/modules/logger';

/**
 * Hook to subscribe to location coordinates via ws-locations-data pubsub
 * Listens for location selection events from ws-location-control widget
 */
export const useLocationCoordinates = () => {
	const [coordinates, setCoordinates] = useState(null);

	useEffect(() => {
		if (!isBrowser) {
			return undefined;
		}

		const locationsData = window?.DDC?.LocationsData;
		if (locationsData?.registerLocationSelectedNotification) {
			const unsubscribe =
				locationsData.registerLocationSelectedNotification((data) => {
					if (data?.coordinates) {
						setCoordinates(data.coordinates);
					}
				});

			const currentCoordinates =
				locationsData.getSelectedLocationCoordinates();
			if (currentCoordinates) {
				setCoordinates(currentCoordinates);
			}

			return unsubscribe;
		}
		logger.warn(
			'[useLocationCoordinates] LocationsData pubsub not available'
		);
		return undefined;
	}, []);

	return coordinates;
};
